export enum EPGErrors {
  EPG_ANOMALY = 'EPG_ANOMALY',
  EPG_EMPTY_RESULTS = 'EPG_EMPTY_RESULTS',
  EPG_SERVICE_ERROR = 'EPG_SERVICE_ERROR',
}
